import React, { useCallback, useEffect, useState } from "react";
import { FaListAlt, FaRegClock } from "react-icons/fa";
import { Link } from "react-router-dom";
import moment from "moment"; // Import moment seperti ini
import "moment/locale/id";
import { slicingWord } from "utils/slicingWord";
import { PaginationPortal } from "components";
import axios from "axios"; // Import axios untuk melakukan HTTP request
import { baseurl } from "constants/api";

const KnowledgeBaseAccordion = ({ category }) => {
  moment.locale("id");
  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [articles, setArticles] = useState(""); // Ganti "article" menjadi "articles" agar sesuai dengan state

  const getKbArticleRelationship = useCallback(async (params) => {
    // Fungsi untuk mendapatkan data dari API
    try {
      const response = await axios.get(
        `${baseurl}/kb/kbarticlerelationship/${params}`
      );
      setArticles(response.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handlePageClick = ({ selected }) => {
    const newOffset = selected * limit;
    const params = `?limit=${limit}&offset=${newOffset}&category_id=${category}`;
    setOffset(newOffset);
    setCurrentPage(selected);
    getKbArticleRelationship(params);
  };

  useEffect(() => {
    //RESET PAGINATE KE 1
    setCurrentPage(0);
    const params = `?limit=${limit}&offset=${0}&category_id=${category}`;
    getKbArticleRelationship(params);
  }, [category, getKbArticleRelationship, limit]);

  return (
    <div className="w-full mx-4 text-gray-800 ">
      {articles !== "" &&
        articles.results.map((item, index) => (
          <div key={index}>
            <div id="Content" key={index} className="mb-4">
              <div className="flex items-center mb-1">
                <FaListAlt className="mr-2 text-gray-500" />
                <Link
                  to={`/pertanyaan/${item.article.slug}`}
                  state={{
                    category: category,
                    category_name: item.category_name,
                  }}
                  className="text-xl font-bold text-sky-500 hover:text-sky-600 text-left"
                >
                  {item.article.name}
                </Link>
              </div>
              <div className="ml-6 px-5 pt-1 bg-gray-100 border-l-4 border-l-gray-300">
                <div
                  className="text-left ck-editor-content"
                  dangerouslySetInnerHTML={{
                    __html: slicingWord(item.article.description, 430),
                  }}
                ></div>
                <div className="text-left">
                  <Link
                    to={`/pertanyaan/${item.article.slug}`}
                    state={{
                      category: category,
                      category_name: item.category_name,
                    }}
                    className="text-sky-500 text-left hover:underline"
                  >
                    Read More
                  </Link>
                </div>
              </div>
              <div className="ml-6 px-5 pt-1 flex items-center">
                <FaRegClock className="text-gray-600 mr-1" />
                <span className="text-xs text-gray-600">
                  {moment(item.article.updated_at).format("dddd, D MMMM YYYY")}
                </span>
              </div>
            </div>
          </div>
        ))}

      <PaginationPortal
        handlePageClick={(e) => handlePageClick(e)}
        pageCount={articles.count > 0 ? articles.count : 0}
        limit={limit}
        offset={offset}
        article={currentPage}
      />
    </div>
  );
};

export default KnowledgeBaseAccordion;
